import React from 'react';
import { Info } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const resolveImg = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  return `${BACKEND_URL}/${url.replace(/^\/+/, '')}`;
};

const getToken = () => localStorage.getItem('admin_token');

const formatPrice = (price, listing_type) => {
  if (price >= 10000000) return `${(price / 10000000).toFixed(2)} Cr`;
  if (price >= 100000) return `${(price / 100000).toFixed(2)} L`;
  return price?.toLocaleString();
};

const MetricInfo = ({ text, position = 'top' }) => (
  <span className="relative group inline-flex ml-1.5 cursor-help">
    <Info className="w-3.5 h-3.5 text-slate-400 hover:text-slate-600 transition-colors" />
    <span className={`absolute ${position === 'bottom' ? 'top-full mt-2' : 'bottom-full mb-2'} left-1/2 -translate-x-1/2 w-56 px-3 py-2 bg-slate-800 text-white text-xs rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-[100] pointer-events-none leading-relaxed shadow-lg`}>
      {text}
      <span className={`absolute ${position === 'bottom' ? 'bottom-full -mb-px border-b-slate-800' : 'top-full -mt-px border-t-slate-800'} left-1/2 -translate-x-1/2 border-4 border-transparent`} />
    </span>
  </span>
);

export { BACKEND_URL, API, resolveImg, getToken, formatPrice, MetricInfo };
